import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const UnallocatedRoutes = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 32 32" fill="none" {...props}>
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path d="M0 0H32V32H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <mask
          id="mask1"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="11"
          width="12"
          height="12"
        >
          <rect y="11" width="11.7411" height="12" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask1)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.42775 17.0009L10.8005 13.5538L9.24385 11.9628L5.87109 15.4099L2.49833 11.9628L0.941675 13.5538L4.31443 17.0009L0.941674 20.4481L2.49833 22.039L5.87109 18.5919L9.24385 22.039L10.8005 20.4481L7.42775 17.0009Z"
            fill={props.fill ? props.fill : "white"}
          />
        </g>
        <path
          d="M27.3102 4H8.51789V8.79323H27.3102V4ZM32 13.6034H14.6056V18.3966H32V13.6034ZM24.957 23.1898H8.51789V28H24.957V23.1898Z"
          fill={props.fill ? props.fill : "white"}
        />
      </g>
    </SvgIcon>
  );
});
